import { Card, CardActionArea, CardContent, CardMedia, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const BlogDetailsBox = ({
    index,
    img,
    title,
    description,
    link
}) => {
    const theme = useTheme();

    const isXS = useMediaQuery(theme.breakpoints.only('xs')); // 0 - 599px

    const navigate = useNavigate();

    const view = useCallback(() => {
        navigate(link);
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Card 
                elevation={3}
                sx={{
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 4,
                    '&: hover': {
                        transform: 'scale(0.99)',
                        color: theme.palette.background.default
                    },
                    minHeight: {xs: 0, md: 500, lg: 450}
                }}
                data-aos="zoom-in"
                data-aos-delay={index * 50}
            >
                <CardActionArea
                    onClick={view}
                >
                    <CardMedia
                        component="img"
                        height={isXS ? 125 : 200}
                        image={img}
                        alt="Thumbnail"
                    />

                    <CardContent sx={{p: 3}}>
                        <Typography 
                            sx={{
                                fontWeight: 800,
                                fontSize: {xs: 12, md: 16},
                                textAlign: "left",
                                lineHeight: 1.5,
                                color: theme.palette.text.primary
                            }}
                        >
                            {title}
                        </Typography>

                        <Typography 
                            sx={{
                                fontWeight: 400,
                                fontSize: {xs: 12, md: 14},
                                textAlign: "left",
                                lineHeight: {xs: 1.5, md: 1.75},
                                pt: {xs: 1, md: 2},
                                color: theme.palette.text.secondary
                            }}
                        >
                           {description}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </>
    );
}

export default BlogDetailsBox;